import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetReplenishmentReport = (params) => {
    return async (dispatch, getState) => {
        try {
            params.search = params.search.replace(/\s/g, '');
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_REPORT_REPLENISHMENT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetReplenishmentReportAction({
                    data: data.data,
                    countPage: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetReplenishmentReport as SetGetReplenishmentReport
}